/** Design tokens som JS-konstanter – speiler CSS @theme-variabler. */
export const colors = {
  base: '#0b0b0f',
  surface: '#111218',
  surfaceRaised: '#1a1b23',
  surfaceOverlay: '#21222c',

  textPrimary: '#ededf0',
  textSecondary: '#8b8d9a',
  textTertiary: '#5e6070',

  accent: '#6366f1',
  accentHover: '#5254cc',
  accentSubtle: '#6366f11f',

  success: '#22c55e',
  warning: '#f59e0b',
  danger: '#ef4444',

  borderHairline: 'rgba(255,255,255,0.07)',
  borderSubtle: 'rgba(255,255,255,0.04)',
} as const;

export const radius = {
  sm: '6px',
  md: '8px',
  lg: '12px',
  xl: '16px',
} as const;

export const shadow = {
  float: '0 8px 32px rgba(0,0,0,0.45), 0 2px 8px rgba(0,0,0,0.3)',
  card: '0 1px 4px rgba(0,0,0,0.25)',
} as const;

export const duration = {
  fast: 150,
  normal: 200,
} as const;

export const spring = {
  snappy: { type: 'spring' as const, stiffness: 400, damping: 30 },
  gentle: { type: 'spring' as const, stiffness: 280, damping: 26 },
} as const;
